import { CacheHelper } from "../../../../utilities/CacheHelper";
import { originOf, parseSpItemUrl, resolveShortcutTargetUrl, shortcutCacheKey, toGridShortcutValue } from "../../services/shortcutPreview";
import { getGridItemUrl } from "./UrlHelper";

const text = (value: unknown): string | undefined =>
    typeof value === "string" && value.trim().length > 0 ? value.trim() : undefined;

/**
 * The URL a click on a .url row opens, or null when the link has no target at all.
 *
 * The shortcut column SharePoint keeps on the row is the fast path and costs nothing. Next
 * comes the session cache the New Link panel and "Share with group" fill for links they have
 * just written. Last, the .url body itself: one small download, then cached, so a link whose
 * column SharePoint has not filled yet still opens. The old code turned a missing value into
 * the text "undefined" and opened a blank tab at "/undefined"; a null here must never reach
 * window.open.
 */
export const resolveShortcutOpenUrl = async (item: any, listHttpRoot?: string): Promise<string | null> => {
    let value: string | undefined = text(item?._ShortcutUrl) ?? text(CacheHelper.get(shortcutCacheKey(item?.UniqueId)));
    if (!value) {
        const ids = parseSpItemUrl(item?.[".spItemUrl"]);
        if (!ids) {
            return null;
        }
        const origin: string = originOf(listHttpRoot) ?? ids.origin;
        const target: string | null = await resolveShortcutTargetUrl({ driveId: ids.driveId, itemId: ids.itemId, uniqueId: item.UniqueId, origin });
        if (!target) {
            return null;
        }
        value = toGridShortcutValue(target, origin);
        if (item.UniqueId) {
            CacheHelper.set(shortcutCacheKey(item.UniqueId), value);
        }
    }
    return getGridItemUrl(item, value, listHttpRoot);
};
